export default __webpack_public_path__ + "static/media/onetime-modal.6c38171e.svg";